import type { ReactNode } from "react";

import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IGenericDropDownItem } from "../types";

/**
 * Default option content for a multi-select SelectCombobox: a text label with a right-aligned
 * checkbox. Mirrors the proven ComboboxWithSelectAll option layout. Use as `renderOption` for flat
 * multi-select filters that don't need custom item rendering (IAB / iOS-primary / industry, etc.).
 */
export const renderCheckboxOption = (item: IGenericDropDownItem<string | number>, isSelected: boolean): ReactNode => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
        gap="8px"
        width="100%"
    >
        <Combobox.OptionLabel>{item.text}</Combobox.OptionLabel>
        <Combobox.OptionCheckbox isChecked={isSelected} />
    </Flex>
);
